import {
  Backdrop,
  Box,
  CircularProgress,
  Fade,
  Typography,
} from '@mui/material';

const FullPageSpinner = ({
  open,
  text = 'Updating',
}: {
  open: boolean;
  text?: string;
}) => {
  return (
    <Fade in={open} timeout={500}>
      <Backdrop
        open={true}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          color: '#fff',
          backdropFilter: 'blur(10px)',
        }}
      >
        <Box display="flex" alignItems="center" justifyContent="center">
          <CircularProgress size={48} sx={{ mr: 2 }} color="inherit" />
          {text && <Typography variant="h4">{text}</Typography>}
        </Box>
      </Backdrop>
    </Fade>
  );
};

export default FullPageSpinner;
